import React, {useCallback, useState} from 'react';
import CustomCheckbox from '@src/components/Fields/CustomCheckbox';
import {IChecklistItemModel} from '@src/@interfaces/models/Checklist/IChecklistItemModel';
import {ICheckedChecklistItemModel} from '@src/@interfaces/models/Checklist/ICheckedChecklistItemModel';
import ConfirmableButton from '@src/components/ConfirmableButton/ConfirmableButton';

const VoidFunction = () => void 0;

function ButtonElement(props: React.ComponentProps<
        Exclude<Required<React.ComponentProps<typeof ConfirmableButton>>['buttonElement'], string>
> & { children: React.ReactNode }) {
    const {onClick, innerRef, children, disabled, ...rest} = props;

    return <div
            {...rest as any}
            onClick={disabled ? undefined : onClick}
            ref={innerRef as any}
    >{children}</div>;
}

export default function ChecklistItem(props: {
    item: IChecklistItemModel,
    checkedItems?: ICheckedChecklistItemModel[],
    onChange?: (item: IChecklistItemModel, value: boolean) => Promise<void>,
    disabled?: boolean,
    readonly?: boolean,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [forceChecked, setForceChecked] = useState<boolean | undefined>();
    const isChecked = forceChecked ?? (
            props.checkedItems
                    ?.find(item => item.checklist_item_id === props.item.id)
                    ?.state === true
    );

    const readonly = props.disabled || props.readonly;
    const {item, onChange: baseOnChange} = props;
    const onChange = useCallback((value: any) => {
        if (!readonly && !isLoading && baseOnChange) {
            setIsLoading(true);
            baseOnChange(item, Boolean(value)).then(() => {
                setForceChecked(Boolean(value));
            }).finally(() => setIsLoading(false));
        }
    }, [baseOnChange, isLoading, item, readonly]);

    return <ConfirmableButton
            type="button"
            onClick={onChange}
            buttonElement={ButtonElement}
            popoverBody="ChecklistsShow.messages.are-you-sure-you-want-to-mark-this-checklist-item-as-completed"
            disabled={item.is_order_completely_payed_item || isChecked}
    >
        <CustomCheckbox
                id={`checklist-item-${item.id}`}
                label={item.title as string}
                disabled={item.is_order_completely_payed_item || isChecked}
                checkedValue={true}
                uncheckedValue={false}
                value={isChecked}
                onChange={VoidFunction}
                isLoading={isLoading}
                readOnly={readonly}
        />
    </ConfirmableButton>;
}
